import kwota from './kwota'
export default {
    required: 'Pole cena jest wymagane',
    ...kwota,
}